import React from "react";

import './App.css';
import './assets/css/all.css';
import './assets/css/bootstrap.min.css';
import './assets/css/mdb.css';
import './assets/css/vvcrm.css';
import './utils/highchart'
import CheckingAccounts from "./components/CheckingAccounts";

function App() {
    return (
        <>
            <div className="container">
                <CheckingAccounts/>
            </div>

            <div className="fixed-bottom p-1 bg-dark">
                <div className="text-center small">
                    Bomber, May the force be with you.
                </div>
            </div>
        </>
    );
}

export default App;
